export const getKeywordGroupStyles = () => ({
  container: {
    marginTop: 4,
  },
  title: {
    marginTop: 4,
    marginBottom: 12,
    fontWeight: 600,
  },
  checkAllLink: {
    marginLeft: 8,
  },
  addAllLink: {
    marginTop: 16,
  },
});
